import script from "./billing.vue?vue&type=script&setup=true&lang=js"
export * from "./billing.vue?vue&type=script&setup=true&lang=js"

import "./billing.vue?vue&type=style&index=0&id=71a4870a&lang=css"

const __exports__ = script;

export default __exports__